import { useProcessIdOnSingleProcessPage } from "components/CustomGridItems/LotInfoBar/lotInfoUtils";
import { ProductionSegmentType } from "types/types";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { ONE_MINUTE_OF_MS } from "utils/timeUtils";
import useQueryWithErrorHandling from "utils/useQuery";
import { PRODUCTION_SEGMENTS_QUERY, askrClients } from "providers/AskrProvider";
import { atom, useAtom } from "jotai";
import { startTransition, useRef, useState } from "react";
import { FETCH_SINGLE_LAST_DATA_DUMP_ROWS_INTERVAL } from "constants/intervals";
import { useInterval } from "react-use";
import { useFlightConfig } from "./FlightConfig/useFlightConfig";
import { useVisibleProcessIds } from "utils/customHooks/genericHooks";

/** fetch Askr current segment for display in HubletView (Askr always returns the full segment) */
export function CurrentSegmentGetter() {
  const visibleProcessIds = useVisibleProcessIds();

  const [toggle, setToggle] = useState(true);
  const ready = visibleProcessIds.length > 0;
  const processId = useProcessIdOnSingleProcessPage();
  const [
    {
      general: { multiplyNetworkRequestIntervals },
    },
  ] = useFlightConfig();

  // refetch on interval
  useInterval(() => {
    setToggle(false);
    setTimeout(() => setToggle(true));
  }, FETCH_SINGLE_LAST_DATA_DUMP_ROWS_INTERVAL * multiplyNetworkRequestIntervals);

  return ready && toggle && processId ? <Query /> : null;
}
function Query() {
  const processId = useProcessIdOnSingleProcessPage();
  const ckey = useCustomerKey();
  // const client = midgardClients.get(ckey);
  const client = askrClients.get(ckey);
  const now = useRef(Date.now());
  useInterval(() => {
    now.current = Date.now();
  }, 1000);
  const [, setCurrentAskrSegment] = useCurrentAskrSegment();
  useQueryWithErrorHandling(
    "CURRENT_SEGMENT_QUERY",
    PRODUCTION_SEGMENTS_QUERY,
    {
      client,
      variables: {
        ge: String(now.current - ONE_MINUTE_OF_MS),
        lt: String(now.current),
        machemetrySourceName: processId,
        // useCache: true,
      },
      onCompleted: data => {
        startTransition(() => {
          const lastSegment =
            data.productionSegments.length === 0
              ? null
              : data.productionSegments[data.productionSegments.length - 1];
          setCurrentAskrSegment(lastSegment);
        });
      },
    }
  );
  return null;
}
const currentAskrSegmentAtom = atom<ProductionSegmentType | null>(null);
export function useCurrentAskrSegment(): [
  ProductionSegmentType | null,
  (currentAskrSegment: ProductionSegmentType | null) => void,
] {
  return useAtom(currentAskrSegmentAtom);
}
